<template>
    <div class="internal-management-section">
        <div v-for="(section, i) in sections" class="my-4" :key="i">
            <app-title :text="section.name" />
            <app-internal-management-section v-for="item in getItemsBySection(section.slug)" :key="item.id" :item="item" />
        </div>
    </div>
</template>
<script>
import InternalManagementSection from './InternalManagementSection/InternalManagementSection.vue';
export default {
    components: {
        appInternalManagementSection: InternalManagementSection
    },
    props: {
        management: {
            type: Array,
            default: []
        }
    },
    methods: {
        getItemsBySection(sectionSlug){
            const items = this.management.filter(item => item.internal_management_type.slug === sectionSlug);
            return items;
        }
    },
    computed: {
        sections(){
            const sections = [];
            this.management.map(item => {
                !sections.find(i => i.id === item.internal_management_type.id) && sections.push(item.internal_management_type);
            });
            return sections;
        }
    }
}
</script>